if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        if (window.VRCart?.add) {
          try {
          const formData = new FormData(this.form);
          const quantity = Number(formData.get('quantity') || 1);
          const sellingPlan = formData.get('selling_plan');
          const properties = Object.fromEntries([...formData.entries()].flatMap(([name,value]) => {
            const match = name.match(/^properties\[(.+)]$/);
            return match && value !== '' ? [[match[1],value]] : [];
          }));
          const addons = window.ConsoleAddons?.getForForm(this.form);
          const accessories = window.VRConsoleAccessories?.getForForm(this.form);
          const accessoryLines = accessories?.buildLines({quantity}) || [];
          const items = addons ? addons.buildLines({variantId:formData.get('id'),quantity,properties,sellingPlan})
            : [{id:Number(formData.get('id')),quantity,properties,...(sellingPlan && {selling_plan:Number(sellingPlan)})}];
          const included = new Set(items.map(item=>Number(item.id)));
          accessoryLines.forEach(item=>{if(Number.isSafeInteger(Number(item.id)) && Number(item.id)>0 && !included.has(Number(item.id))) {included.add(Number(item.id));items.push(item);}});
          this.closest('quick-add-modal')?.hide(true);
            await window.VRCart.add({items},this.submitButton);
            if (accessoryLines.length) accessories.markAdded();
            window.VRAccessoryTest?.track('add_to_cart',{product_variant_id:String(formData.get('id')),quantity,accessory_count:accessoryLines.length});
            window.VRExperiments?.track?.('add_to_cart',{product_variant_id:String(formData.get('id')),quantity});
            this.error = false;
          } catch (error) {
            this.error = Boolean(error.cartWritten);
            this.handleErrorMessage(error.cartWritten ? 'Bitte prüfe den Warenkorb, bevor du erneut hinzufügst.' : error.message);
          } finally {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          }
          return;
        }
        await window.VRAccessoryTest?.prepareCart();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const consoleAddons = window.ConsoleAddons?.getForForm(this.form);
        const accessories = window.VRConsoleAccessories?.getForForm(this.form);
        const accessoryLines = accessories?.buildLines({ quantity: Number(formData.get('quantity') || 1) }) || [];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.routes.cart_url);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        let addToCartRequest;

        if (consoleAddons || accessoryLines.length) {
          const quantity = Number(formData.get('quantity') || 1);
          const sellingPlan = formData.get('selling_plan');
          const properties = window.ConsoleAddons?.propertiesFromFormData
            ? window.ConsoleAddons.propertiesFromFormData(formData)
            : Object.fromEntries(
                Array.from(formData.entries()).flatMap(([name, value]) => {
                  const match = name.match(/^properties\[(.+)]$/);
                  return match && value !== '' ? [[match[1], value]] : [];
                })
              );
          const items = consoleAddons
            ? consoleAddons.buildLines({
                variantId: formData.get('id'),
                quantity,
                properties,
                sellingPlan,
              })
            : [{
                id: Number(formData.get('id')),
                quantity,
                properties,
                ...(sellingPlan && { selling_plan: Number(sellingPlan) }),
              }];
          const includedVariantIds = new Set(items.map((item) => Number(item.id)));
          accessoryLines.forEach((item) => {
            const id = Number(item.id);
            if (!Number.isSafeInteger(id) || id <= 0 || includedVariantIds.has(id)) return;
            includedVariantIds.add(id);
            items.push(item);
          });

          const batchConfig = fetchConfig('javascript');
          batchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          batchConfig.body = JSON.stringify({
            items,
            ...(this.cart && {
              sections: this.cart.getSectionsToRender().map((section) => section.id),
              sections_url: window.routes.cart_url,
            }),
          });
          addToCartRequest = fetch(`${routes.cart_add_url}`, batchConfig);
        } else {
          addToCartRequest = fetch(`${routes.cart_add_url}`, config);
        }

        addToCartRequest
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            window.VRAccessoryTest?.track('add_to_cart', { product_variant_id: String(formData.get('id') || ''), quantity: Number(formData.get('quantity') || 1), accessory_count: accessoryLines.length });
            if (!this.cart) {
              if (accessoryLines.length) {
                await window.VRCheckoutContents?.sync();
                accessories.markAdded();
              }
              window.location = window.routes.cart_url;
              return;
            }

            const addedConsoleItem = Array.isArray(response.items)
              ? response.items.find((item) => String(item.id) === String(formData.get('id'))) || response.items[0]
              : response;
            window.VRExperiments?.track?.('add_to_cart', {
              product_variant_id: String(formData.get('id') || ''),
              quantity: Number(formData.get('quantity') || 1),
            });
            let cartResponse = Array.isArray(response.items)
              ? { ...response, ...addedConsoleItem, sections: response.sections, key: addedConsoleItem?.key }
              : response;
            if (accessoryLines.length) accessories.markAdded();
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) quickAddModal.hide(true);
            if (window.VRCart) {
              await window.VRCart.open(this.submitButton);
            } else {
              await window.VRCheckoutContents?.sync();
              cartResponse.sections = null;
              this.cart.renderContents(await this.ensureCartSections(cartResponse));
            }
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', productVariantId: formData.get('id'), cartData: cartResponse });
          })
          .catch((e) => {
            console.error(e);
            // A transport/render error can happen after Shopify already added the item.
            // Show the actual cart instead of allowing a potentially duplicate retry.
            this.error = true;
            if (window.VRCart) window.VRCart.open(this.submitButton);
            else window.location = window.routes.cart_url;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      async ensureCartSections(cartResponse) {
        if (!this.cart) return cartResponse;

        const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
        const hasAllSections =
          cartResponse?.sections &&
          sectionIds.every((sectionId) => typeof cartResponse.sections[sectionId] === 'string');
        if (hasAllSections) return cartResponse;

        const sectionUrl = new URL(window.routes.cart_url, window.location.origin);
        sectionUrl.searchParams.set('sections', sectionIds.join(','));

        const currentParams = new URLSearchParams(window.location.search);
        ['_fd', 'preview_theme_id'].forEach((parameter) => {
          if (currentParams.has(parameter)) sectionUrl.searchParams.set(parameter, currentParams.get(parameter));
        });
        if (!sectionUrl.searchParams.has('preview_theme_id') && window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id) {
          sectionUrl.searchParams.set('preview_theme_id', window.Shopify.theme.id);
        }

        const response = await fetch(sectionUrl.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Cart sections could not be refreshed.');

        const sections = await response.json();
        const hasRefreshedSections = sectionIds.every((sectionId) => typeof sections?.[sectionId] === 'string');
        if (!hasRefreshedSections) throw new Error('Cart sections are unavailable.');

        return { ...cartResponse, sections };
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
